import * as React from 'react'
import { Loader2 } from 'lucide-react'
import type { LinksFunction } from 'react-router'
import { Links, Meta, Outlet, Scripts, ScrollRestoration, useRouteError } from 'react-router'

import { Toaster } from '@modules/shadcn/ui/Toast/Toaster'

import { RouteErrorScreen } from '@admin/template/RouteErrorScreen/RouteErrorScreen'

import { useAuthListener } from './auth/auth'
import { ConnectProvider, CustomProvider } from './context/CustomProvider'

import '@modules/scss/global.css'

const Head = () => {
  return (
    <head>
      <Meta />
      <Links />
      <link href="https://fonts.googleapis.com" rel="preconnect" />
      <link href="https://fonts.gstatic.com" rel="preconnect" />
      <link
        href="https://fonts.googleapis.com/css2?family=Inter:wght@100;400;700;900&display=swap"
        rel="stylesheet"
      />
      <link href="/img/icon_admin.svg" rel="icon" />
      <link href="/img/icon_180-180.png" rel="apple-touch-icon" sizes="180x180" />
    </head>
  )
}

export const links: LinksFunction = () => {
  return [
    // { rel: 'stylesheet', href: stylesheet },
  ]
}

export const clientLoader = () => {
  return null
}

const Document: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return (
    <html>
      <Head />
      <body>
        {children}
        <Toaster />
        <ScrollRestoration />
        <Scripts />
      </body>
    </html>
  )
}
const CustomApp = ({ children }: { children: React.ReactNode }) => {
  // 認証状態リスナーはアプリ全体でここ1本だけにする（増やすとGetAdminMeが本数ぶん飛ぶ）
  const { loading } = useAuthListener()
  return !loading && <>{children}</>
}

const App = () => {
  return (
    <Document>
      <CustomProvider>
        <ConnectProvider>
          <CustomApp>
            <Outlet />
          </CustomApp>
        </ConnectProvider>
      </CustomProvider>
    </Document>
  )
}
export default App

export const HydrateFallback = () => {
  return (
    <Document>
      <div className="flex items-center justify-center min-h-screen">
        <Loader2 className="animate-spin h-8 w-8 text-muted-foreground" />
      </div>
      <Scripts />
    </Document>
  )
}

export const ErrorBoundary = () => {
  const error = useRouteError()
  console.error(error)
  return (
    <Document>
      <RouteErrorScreen error={error} />
      <Scripts />
    </Document>
  )
}
